import React from 'react';
import {
  ButtonIcon,
  Container,
  ContainerIcons,
  DesktopIcon,
  MobileIcon,
  PreviewTitle,
} from './HeaderPreview.styles';
import { HeaderPreviewProps } from './HeaderPreview.types';

export function HeaderPreview({ isPreviewDesktop, onChange }: HeaderPreviewProps) {
  return (
    <Container>
      <PreviewTitle>Pré visualização</PreviewTitle>
      <ContainerIcons>
        <ButtonIcon onClick={() => onChange(true)} active={isPreviewDesktop}>
          <DesktopIcon size={24} active={isPreviewDesktop} />
          <span>Computador</span>
        </ButtonIcon>
        <ButtonIcon onClick={() => onChange(false)} active={!isPreviewDesktop}>
          <MobileIcon size={24} active={!isPreviewDesktop} />
          <span>Celular</span>
        </ButtonIcon>
      </ContainerIcons>
    </Container>
  );
}
